<template>
  <div class="table-responsive">
    <table class="table table-flush">
      <thead class="thead-light">
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th class="text-center" v-if="hasRoles(['roleChange', 'roleRead'])">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!users">
          <td align="center" colspan="100%">No row found</td>
        </tr>
        <tr v-for="user of users" :key="user.id">
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td class="text-center" v-if="hasRoles(['roleChange', 'roleRead'])">
            <button
              data-toggle="modal"
              data-target="#editUser"
              @click="$parent.editingUser = user"
              type="button"
              class="btn btn-sm btn-dark btn-icon-only rounded-circle mt-1"
            >
              <i class="fa fa-pen"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

export default {
  name: "users-table",
  props: {
    users: Array
  },
  methods: {
    hasRoles: function(roles) {
      return roles.every(this.hasRole);
    },
    hasRole: function(role) {
      return this.rolesData[role] != null || this.isOwner;
    }
  },
  computed: {
    curOrg() {
      return this.$store.state.usermain.curOrg;
    },
    currentUser() {
      return this.$store.state.usermain.currentUser;
    },
    isOwner() {
      return this.$store.state.usermain.isOwner;
    },
    rolesData() {
      return this.$store.state.usermain.rolesData;
    }
  }
};
</script>
